import { render, staticRenderFns } from "./centerItem.vue?vue&type=template&id=17fe1d6e&scoped=true"
import script from "./centerItem.vue?vue&type=script&lang=js"
export * from "./centerItem.vue?vue&type=script&lang=js"
import style0 from "./centerItem.vue?vue&type=style&index=0&id=17fe1d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fe1d6e",
  null
  
)

export default component.exports